import { useEffect, useState } from "react";

const FOOTER_LINKS = [
  { key: "hot", label: "今日热榜" },
  { key: "timeline", label: "时间线复盘" },
  { key: "review", label: "深度复盘" },
  { key: "channels", label: "栏目分类" },
  { key: "faq", label: "常见问题" },
  { key: "subscribe", label: "订阅推送" },
];

export default function SiteFooter() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (key: string) => {
    if (key === "top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    document.getElementById(key)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="w-full border-t border-background-200 bg-background-200/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <button onClick={() => goTo("top")} className="flex items-center gap-2.5 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 text-lg">
                <i className="ri-water-flash-line"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                今日看<span className="text-primary-600">瓜</span>
              </span>
            </button>
            <p className="mt-4 max-w-xs text-sm text-foreground-600 leading-relaxed">
              专注事件梳理与完整时间线复盘的内容平台，把每个大瓜的来龙去脉一次讲清。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-douban-line"].map((ic) => (
                <button
                  key={ic}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                  aria-label="关注今日看瓜"
                >
                  <i className={`${ic} text-lg`}></i>
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950">快速导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3">
              {FOOTER_LINKS.map((l) => (
                <li key={l.key}>
                  <button onClick={() => goTo(l.key)} className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600 whitespace-nowrap">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i> hi@jinrikan-gua.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500"></i> 内容更新：全天候跟进热点
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-message-3-line text-primary-500"></i> 反馈纠错 / 补档建议
              </li>
            </ul>
            <button
              onClick={() => goTo("subscribe")}
              className="mt-5 inline-flex cursor-pointer items-center gap-2 rounded-full bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600 whitespace-nowrap"
            >
              订阅推送 <i className="ri-send-plane-line"></i>
            </button>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-300/60 pt-6">
          <p className="text-xs text-foreground-500">© 2026 今日看瓜 · 事件梳理与时间线复盘内容平台 · 保留所有权利</p>
          <p className="text-xs text-foreground-500">信息整理自公开来源，仅作内容梳理，请理性看待。</p>
        </div>
      </div>

      {showTop && (
        <button
          onClick={() => goTo("top")}
          aria-label="回到顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}
    </footer>
  );
}